import { CurrencyConverter } from '@fiverr-private/futile/lib/number';

class GigCurrencyConverter {

    constructor(currency) {
        this.currencyConverter = new CurrencyConverter(currency);
        this.options = {
            commaSeparate: true
        };
        this.currency = currency;
    }

    convert(price) {
        return this.currencyConverter.convert(price/100, this.options);
    }

    getCurrency() {
        return this.currency;
    }
}

export default GigCurrencyConverter;
